module.exports = __webpack_public_path__ + "static/media/tree-loader.90d0e45e918404675c34652a4ec2f68c.gif";